import { FutureDevelopmentPlaceholder } from "features/common/ui/FutureDevelopmentPlaceholder"

export const MyUploadsPage = () => {
  return (
    <FutureDevelopmentPlaceholder />  
  )
} 